var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": _vm.dataForm.id ? 'Edit Client' : 'Add Client',
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "780px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-width": "186px"
    }
  }, [!_vm.dataForm.id ? _c('el-form-item', {
    attrs: {
      "label": "Copy From",
      "prop": "copyFromId"
    }
  }, [_c('engagement-select-remote-search', {
    attrs: {
      "placeholder": "Select an existing data to copy"
    },
    on: {
      "change-item": _vm.copyFromChange
    },
    model: {
      value: _vm.dataForm.copyFromId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "copyFromId", $$v);
      },
      expression: "dataForm.copyFromId"
    }
  })], 1) : _vm._e(), _c('el-form-item', {
    attrs: {
      "prop": "clientCode"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" Client Code "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "fs12"
  }, [_vm._v("Data Source: \"Client Code\" section of this system")]), _c('span', {
    staticClass: "pearl-blue fs16 el-icon-warning",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _c('client-code-select-remote-search', {
    attrs: {
      "placeholder": "Client Code"
    },
    model: {
      value: _vm.dataForm.clientCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "clientCode", $$v);
      },
      expression: "dataForm.clientCode"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "UEN",
      "prop": "uen"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "UEN",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.uen,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "uen", $$v);
      },
      expression: "dataForm.uen"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Entity Name",
      "prop": "companyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Entity Name",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "companyName", $$v);
      },
      expression: "dataForm.companyName"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Entity Country",
      "prop": "companyCountry"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "placeholder": "Select Entity Country",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.companyCountry,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "companyCountry", $$v);
      },
      expression: "dataForm.companyCountry"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Entity Type",
      "prop": "companyType"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "placeholder": "Select Entity Type",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.companyType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "companyType", $$v);
      },
      expression: "dataForm.companyType"
    }
  }, _vm._l(_vm.engagementCompanyTypeList, function (item) {
    return _c('el-option', {
      key: item.title,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "flex"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Covered Period",
      "prop": "coveredPeriodStart"
    }
  }, [_c('el-date-picker', {
    staticClass: "wd256",
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Start Date"
    },
    model: {
      value: _vm.dataForm.coveredPeriodStart,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "coveredPeriodStart", $$v);
      },
      expression: "dataForm.coveredPeriodStart"
    }
  })], 1), _c('span', {
    staticClass: "lh36 pl15 pr15"
  }, [_vm._v("~")]), _c('el-form-item', {
    staticClass: "labelNone",
    attrs: {
      "prop": "coveredPeriodEnd"
    }
  }, [_c('el-date-picker', {
    staticClass: "wd256",
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "End Date"
    },
    model: {
      value: _vm.dataForm.coveredPeriodEnd,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "coveredPeriodEnd", $$v);
      },
      expression: "dataForm.coveredPeriodEnd"
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Incorp. date",
      "prop": "incorpDate"
    }
  }, [_c('el-date-picker', {
    staticClass: "wdb100",
    attrs: {
      "type": "date",
      "placeholder": "Incorp. date",
      "format": _vm.dataForm.incorpDate ? "dd [".concat(_vm.monthList[parseInt(_vm.dataForm.incorpDate.split('-')[1]) - 1], "] yyyy") : 'dd MM yyyy',
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: _vm.dataForm.incorpDate,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "incorpDate", $$v);
      },
      expression: "dataForm.incorpDate"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Previous Entity Name",
      "prop": "previousCompanyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Previous Entity Name",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.previousCompanyName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "previousCompanyName", $$v);
      },
      expression: "dataForm.previousCompanyName"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Type",
      "prop": "type"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "placeholder": "Type",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.type,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "type", $$v);
      },
      expression: "dataForm.type"
    }
  })], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }